import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { useGetFilters } from "../hooks/useGetFilters";
import { useGetRows } from "../hooks/useGetRows";
import { useGetColumns } from "../hooks/useGetColumns";
import { ControlVisitaFilters } from "./ControlVisitaFilters";

export const ControlVisitaContent = () => {
    const {
        paramsLoading,
        delegaciones,
        delegacionOrigen,
        tipoProfesionales,
        estadosOptions,
        aniosOptions,
        mesesEnum,
        filters,
        handleChangeFilters,
        applyClientSideFilters
    } = useGetFilters();

    const {
        rows,
        setRows,
        loading,
        totalCount,
        handleSearch,
    } = useGetRows(filters, applyClientSideFilters);

    const columns = useGetColumns({ filters: filters, handleSearch: handleSearch });

    return (<>
        <ControlVisitaFilters
            delegaciones={delegaciones}
            estadosOptions={estadosOptions}
            tipoProfesionalesOptions={tipoProfesionales}
            aniosOptions={aniosOptions}
            mesesEnum={mesesEnum}
            filters={filters}
            handleChangeFilters={handleChangeFilters}
            handleSearch={handleSearch}
        />
        <DataGridGenerico
            columns={columns}
            rows={rows}
            autoMaxWidth
            totalCount={totalCount}
            toolbar={false}
            loading={loading}
        />
    </>);
}